import { useState } from "react";
import { Button } from "@/components/base/buttons/button";
import { RequestCustomRiskModal } from "../../components/RequestCustomRiskModal/RequestCustomRiskModal";

export const RiskCtaBanner = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <div
        className="relative rounded-2xl overflow-hidden flex items-center gap-8 px-8 pt-8 pb-10 mt-2"
        style={{ background: "linear-gradient(180deg, #2E1F3A 0%, #3E2356 100%)" }}
      >
        {/* Text */}
        <div className="flex-1 min-w-0 relative z-10">
          <p className="text-md font-medium text-white mb-1">Looking for a custom risk setup?</p>
          <p className="text-sm text-[#E9D7FE] leading-relaxed max-w-xl">
            Get in touch to talk to us about how we can run your videos against other risks that are important to your
            brand.
          </p>
        </div>

        {/* Halftone portrait — fades into background */}
        <div className="absolute right-48 top-0 bottom-0 w-[250px] pointer-events-none select-none" aria-hidden="true">
          <img
            src="/safety/aa254be04a7ba1180f1bbe583d7b9922e26a1a8a.png"
            alt=""
            className="h-[170%] w-full object-cover opacity-50"
            style={{ maskImage: "linear-gradient(to right, transparent, white 40%, white 80%, transparent)" }}
          />
        </div>

        {/* Button */}
        <div className="relative z-10 shrink-0">
          <Button color="secondary" size="sm" onClick={() => setModalOpen(true)}>
            Request custom risk
          </Button>
        </div>
      </div>

      <RequestCustomRiskModal open={modalOpen} onOpenChange={setModalOpen} />
    </>
  );
};
